import React from 'react';
import { Navigate } from 'react-router-dom';

import { useSelectorUserInfo } from '@/components/auth/AuthContext';
import Loader from '@/components/common/loader/Loader';
import { getRedirectPathByUser } from '@/routes/redirect';

/**
 * Root path lands each role on the screen it can actually use. Shares the
 * destination logic with the post-login redirect so the two stay in step.
 */
const HomeRedirect: React.FC = () => {
  const { currentUser } = useSelectorUserInfo();

  if (!currentUser?.current_roles?.length) {
    return <Loader isLoading />;
  }

  return <Navigate to={getRedirectPathByUser(currentUser)} />;
};

export default HomeRedirect;
